import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getCachedRole, getUserProfile, isSignedOutError } from "../controllers/utilityController";

// Signed-in pages. People stay signed in until they sign out or the server rejects the token (401):
// a failed check for any other reason (offline, a slow network, a server restart) keeps them in and
// uses the role from their last successful check.
const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const allows = (role) => allowedRoles.length === 0 || allowedRoles.includes(role);

    const validateAccess = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setIsAuthorized(false);
        setLoading(false);
        return;
      }

      try {
        const res = await getUserProfile();
        setIsAuthorized(allows(res.role));
      } catch (err) {
        if (isSignedOutError(err)) {
          setIsAuthorized(false);
        } else {
          console.warn("Couldn't check the session, staying signed in:", err);
          const cachedRole = getCachedRole();
          setIsAuthorized(!cachedRole || allows(cachedRole));
        }
      } finally {
        setLoading(false);
      }
    };

    validateAccess();
  }, [allowedRoles]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return isAuthorized ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
